import { render, staticRenderFns } from "./LayoutAuthSidebarWaves.vue?vue&type=template&id=9726feaa&scoped=true&"
import script from "./LayoutAuthSidebarWaves.vue?vue&type=script&lang=ts&"
export * from "./LayoutAuthSidebarWaves.vue?vue&type=script&lang=ts&"
import style0 from "./LayoutAuthSidebarWaves.vue?vue&type=style&index=0&id=9726feaa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../common/temp/node_modules/.pnpm/vue-loader@15.9.8_679359cdb69c218f2f8f476b2ba08796/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9726feaa",
  null
  
)

export default component.exports